<template>
  <div class="grouped-row-card">
    <div class="grouped-row-voucher px-3 pt-3 pb-2">
      <div class="row">
        <div class="col-6 col-md-3">
          <div class="color-secondary-6 font-14">Voucher ID:</div>
          <div class="color-black font-weight-bold font-14">
            {{ value.voucherId || '-' }}
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="color-secondary-6 font-14">Fecha de Voucher:</div>
          <div class="color-black font-weight-bold font-14">
            <span v-if="value.voucherDate">{{ value.voucherDate | date }}</span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="col-6 col-md-3 mt-2 mt-md-0">
          <div class="color-secondary-6 font-14">
            Número de Referencia de Pago:
          </div>
          <div class="color-black font-weight-bold font-14">
            {{ value.paymentReferenceNumber || '-' }}
          </div>
        </div>
        <div class="col-6 col-md-3 mt-2 mt-md-0">
          <div class="color-secondary-6 font-14">Fecha de Pago:</div>
          <div class="color-black font-weight-bold font-14">
            <span v-if="value.paymentDate">{{ value.paymentDate | date }}</span>
            <span v-else>-</span>
          </div>
        </div>
      </div>
    </div>
    <custom-callout
      class="callout__extended grouped-row-callout"
      :controlled="true"
      :opened="isOpen"
      @click:open="onToggleDetails"
    >
      <div class="row mt-3 align-items-center pb-2">
        <div class="col-3">
          <div class="color-secondary-6 font-14">Estudiante:</div>
          <div class="color-black font-weight-bold font-16">
            {{ value.studentFullName }}
          </div>
        </div>
        <div class="col">
          <div class="color-secondary-6 font-14">SIE:</div>
          <div class="color-black font-weight-bold font-16">
            {{ value.studentSieId }}
          </div>
        </div>
        <div class="col mt-3 mt-md-0">
          <div class="color-secondary-6 font-14">Conteo de Servicios:</div>
          <div class="color-black font-weight-bold font-16">
            {{ value.serviceCount }}
          </div>
        </div>
        <div class="col mt-3 mt-md-0">
          <div class="color-secondary-6 font-14">Costo Total:</div>
          <div class="color-black font-weight-bold font-16">
            {{ value.studentTotalAmt | price }}
          </div>
        </div>
        <div class="col mt-3 mt-md-0">
          <div class="color-secondary-6 font-14">Estatus:</div>
          <div class="color-black font-weight-bold font-16">
            <i class="fas fa-circle mr-1" :class="`color-${statusColor}`" />
            {{ statusName }}
          </div>
        </div>
        <div class="col d-flex justify-content-end mt-3 mt-md-0">
          <drop-down :data-item="{ item: value, index }" :items="actionItems" />
        </div>
      </div>
      <template #edition>
        <add-payment-voucher
          v-if="showAddVoucher"
          :initial-voucher-date="value.voucherDate"
          :initial-voucher-number="value.voucherId"
          @on-cancel="onVoucherCancel"
          @on-save="onVoucherSave"
        />
        <add-payment-reference
          v-else-if="showAddPaymentReference"
          @on-cancel="onPaymentReferenceCancel"
          @on-save="onPaymentReferenceSave"
        />
        <payment-student-services v-else :services="value.services" />
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import AddPaymentVoucher from './AddPaymentVoucher';
import AddPaymentReference from './AddPaymentReference';
import PaymentStudentServices from './PaymentStudentServices';
import PaymentJournalStudentStatus from '@/utils/constants/paymentJournalStudentStatus';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus';

export default {
  name: 'PaymentInfoGroupedRow',
  components: {
    CustomCallout,
    DropDown,
    AddPaymentVoucher,
    AddPaymentReference,
    PaymentStudentServices,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    journalStatus: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isOpen: false,
      showAddVoucher: false,
      showAddPaymentReference: false,
    };
  },
  computed: {
    statusName() {
      return (
        this.value.paymentJournalStudentStatusName || 'Pendiente de Voucher'
      );
    },
    statusColor() {
      switch (this.value.paymentJournalStudentStatusId) {
        case PaymentJournalStudentStatus.VoucherRegistrado:
          return 'green-light';
        case PaymentJournalStudentStatus.Pagado:
          return 'celadon';
        default:
          return 'secondary-23';
      }
    },
    actionItems() {
      return [
        {
          name: 'toggle-details',
          label: 'Ver Detalles',
          icon: 'fas fa-eye color-primary-1',
          click: () => {
            this.onToggleDetails();
          },
        },
        {
          name: 'voucher-action',
          label:
            this.value.paymentJournalStudentStatusId ===
            PaymentJournalStudentStatus.VoucherRegistrado
              ? 'Editar Voucher'
              : 'Añadir Voucher',
          icon:
            this.value.paymentJournalStudentStatusId ===
            PaymentJournalStudentStatus.VoucherRegistrado
              ? 'fas fa-edit color-primary-1'
              : 'fas fa-plus-circle color-primary-1',
          visible:
            this.journalStatus !== paymentJournalStatus.EnviadoAFinanzas &&
            (this.value.paymentJournalStudentStatusId ===
              PaymentJournalStudentStatus.PendienteDeVoucher ||
              this.value.paymentJournalStudentStatusId ===
                PaymentJournalStudentStatus.VoucherRegistrado),
          click: () => {
            this.showAddVoucher = true;
            this.isOpen = true;
          },
        },
        {
          name: 'payment-reference-action',
          label: 'Registrar Pago',
          icon: 'fas fa-money-bill-wave color-primary-1',
          visible:
            this.journalStatus === paymentJournalStatus.EnviadoAFinanzas &&
            this.value.paymentJournalStudentStatusId !==
              PaymentJournalStudentStatus.Pagado,
          click: () => {
            this.showAddPaymentReference = true;
            this.isOpen = true;
          },
        },
      ];
    },
  },
  methods: {
    onToggleDetails() {
      this.isOpen = !this.isOpen;
    },
    onVoucherSave(voucher) {
      this.$emit('on-save-voucher', { item: this.value, voucher });
      this.showAddVoucher = false;
      this.isOpen = false;
    },
    onVoucherCancel() {
      this.showAddVoucher = false;
      this.isOpen = false;
    },
    onPaymentReferenceSave(paymentReference) {
      this.$emit('on-save-payment-reference', {
        item: this.value,
        paymentReference,
      });
      this.showAddPaymentReference = false;
      this.isOpen = false;
    },
    onPaymentReferenceCancel() {
      this.showAddPaymentReference = false;
      this.isOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.grouped-row-card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.grouped-row-voucher {
  background-color: map-get($colors, 'mint-cream-100');
  border-radius: 4px 4px 0 0;
}

.grouped-row-callout {
  border-radius: 0 0 6px 6px !important;
  box-shadow: none !important;
  margin-bottom: 20px;
}
</style>
